module.exports = __webpack_public_path__ + "img/Y0.088ae83a.png";